module.exports = __webpack_public_path__ + "img/404.0472a02f.svg";